// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      setError("Missing session_id in URL");
      return;
    }

    (async () => {
      try {
        const { data } = await api.post(
          "/auth/login",
          { session_id: sessionId },
          { withCredentials: true }
        );
        setUser(data);
        toast.success(`Welcome, ${data.name}`);
        navigate("/", { replace: true, state: { user: data } });
      } catch (err) {
        const msg = err?.response?.data?.detail || err.message || "Auth exchange failed";
        setError(msg);
        toast.error("Sign-in failed", { description: msg });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center radar-grid-bg">
      <div className="text-center">
        {!error ? (
          <>
            <div className="radar-sweep mx-auto mb-5"/>
            <div className="kpi-label text-[#0A84FF]">/ SIGNING YOU IN</div>
            <div className="text-sm text-[#A3A3A3] mt-2">Authenticating with Google…</div>
          </>
        ) : (
          <>
            <div className="kpi-label text-[#FF453A] mb-2">/ SIGN-IN FAILED</div>
            <div className="font-display text-2xl text-white mb-2">Could not complete sign-in</div>
            <div className="text-sm text-[#A3A3A3] max-w-md mx-auto">{error}</div>
            <button
              type="button"
              onClick={() => (window.location.href = "/login")}
              data-testid="back-to-login-btn"
              className="mt-5 h-9 px-4 rounded-sm bg-[#0A84FF] hover:bg-[#409CFF] text-white text-xs font-mono-data tracking-wider uppercase"
            >
              Back to login
            </button>
          </>
        )}
      </div>
    </div>
  );
}
